import React from "react";
import "./WhyChooseUs.css";
import "bootstrap/dist/css/bootstrap.min.css";
import shapewcu from "../../media/shapewcu.png";
import { motion } from "framer-motion";

// Variants
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.3,
      delayChildren: 0.2,
    },
  },
};

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 1.2, ease: "easeOut" },
  },
};

const WhyChooseUs = () => {
  return (
    <section className="py-5">
      <div className="container-md">
        <motion.div
          className="why-choose-us position-relative overflow-hidden rounded-4"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <div className="overlay"></div>
          <div className="overlay-2"></div>

          {/* Animated Decorative Shape */}
          <motion.div
            className="shape-wcu"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, ease: "easeOut", delay: 0.5 }}
          >
            <img src={shapewcu} alt="Decorative shape" />
          </motion.div>

          {/* Content */}
          <motion.div className="content text-white">
            <motion.h2 className="section-title mb-3" variants={fadeUp}>
              At Aspen SR, we believe financial clarity is the foundation of
              sustainable growth of your dream. We don’t just manage numbers -
              we empower your decisions. We’re not just your accountants - we’re
              your partners in progress!
            </motion.h2>

            <motion.p className="owner-name mb-0" variants={fadeUp}>
              — RC Panta
            </motion.p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
